module.exports = __webpack_public_path__ + "img/demo3.d5018b37.png";